var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.$config.base_url + 'img/icons/BukaKasir.png',"alt":"BukaKasir Logo"}}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-dots"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"})])
}]

export { render, staticRenderFns }